import withReducer from "app/store/withReducer";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import FuseUtils from "@fuse/utils";
import { authPermissions } from "app/auth";
import { AuraSimplePageRoot } from "app/main/apps/common/AuraFunctions";
import reducer from "app/store/userSlice";
import ViewOrderDialog from "app/main/dashboards/main/dialogs/ViewOrderDialog";
import ContainersContent from "./ContainersContent";
import AuraHeader from "../../common/AuraHeader";
import { getOrderStatuses } from "../../e-commerce/store/ordersSlice";
import OrderDialog from "../../e-commerce/order/Dialogs/OrderDialog";

// Main page for showing the containers content parent for create container and table
const Containers = () => {
  const currentUser = useSelector(({ user }) => user);
  const dispatch = useDispatch();
  const isManage =
    currentUser &&
    FuseUtils.hasPermission(authPermissions.manage, currentUser.role);
  const pageLayout = useRef(null);
  const loadStatusesNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.loadStatusesNames
  );
  const containerShipmentNames = useSelector(
    ({ eCommerceApp }) => eCommerceApp.orders.containerShipmentNames
  );

  const headerData = {
    headerTitle: "Container Management",
    headerClassName: 'md:p-16',
    pageLayout,
    isManage,
  };

  useEffect(() => {
    if (!loadStatusesNames || loadStatusesNames.length === 0) {
      dispatch(
        getOrderStatuses({ params: { c: "container_management_status" } })
      );
    }
    if (!containerShipmentNames || containerShipmentNames.length === 0) {
      dispatch(getOrderStatuses({ params: { c: "container_shipment" } }));
    }
  },[]);

  return (
    <>
      <AuraSimplePageRoot
        header={<AuraHeader {...headerData} />}
        content={<ContainersContent />}
        scroll="body"
      />
      <ViewOrderDialog />
      <OrderDialog />
    </>
  );
};

export default withReducer("backofficeApp", reducer)(Containers);
